import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import { userAction } from '@/util/helpers/ajax-helpers';
import CategoryRef from '@/util/CategoryRef';
import { checkIfValidUUID } from '@/components/AppNavigation/navigation-helpers';
import {
  changeTab,
  deleteView,
  editView,
  modalInteraction,
  openModal,
  openReactModal,
  removeCategory,
  searchPerformed,
  starClicked,
} from '../../actions';
import { VIEWS_TAB } from '../../util/enums/EnumModals';

import { EXPLORER, VIEWS } from '../../util/enums/views.constants';

import ModalImportViews from '../../components/modals/ModalImportViews';

import ShareInsightPage from '../../components/share/ShareInsightPage';
import ModalDuplicateView from '../../components/modals/ModalDuplicateView';
import { MAX_TEXTFIELD_LENGTH } from '../../reducers/modal_save_layers';
import ModalEditCategory from '../../components/ModalEditCategory';
import { SavedQueries_LEGACY } from './SavedQueries_LEGACY';

const SavedQueries = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const categoryId = searchParams.get('category');

  React.useEffect(() => {
    if (categoryId) {
      const category = checkIfValidUUID(categoryId)
        ? new CategoryRef(categoryId, null, null)
        : categoryId;

      dispatch(
        modalInteraction(VIEWS_TAB, {
          section: 'filter',
          categoryFilter: category,
        }),
      );

      // TODO: this feels like a hack and a wrong UX. We should preserve applied filters in URL. Needs to be clarified.
      navigate('../saved-queries');
    }
  }, [categoryId]);

  return <SavedQueries_LEGACY {...props} />;
};

const mapStateToProps = (state) => {
  return {
    state: state.views,
    userEmail: state.datasource.userEmail,
    suggestions: state.datasource.suggestions,
    myViews: state.datasource.views,
    isHerokuAddonUser:
      state.datasource.isHerokuBeta && state.datasource.isOwner,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onDeleteView: (view) => () => {
      dispatch(deleteView(view));
    },
    onEditView: (view) => (e) => {
      e.preventDefault();
      dispatch(editView(view));
    },
    onDuplicateView: (view) => (e) => {
      e.preventDefault();
      const newName =
        view.name() + ' (copy)'.substring(0, MAX_TEXTFIELD_LENGTH);
      dispatch(
        openReactModal(<ModalDuplicateView original={view} name={newName} />),
      );
    },
    onOpenShareModal: (viewBeingEdited) => (tabToOpen) => (e) => {
      e.preventDefault();
      dispatch(
        openReactModal(
          <ShareInsightPage
            viewToShare={viewBeingEdited}
            initialOption={tabToOpen}
          />,
        ),
      );
    },
    onSearchPerformed: (search) => (e) => {
      e.preventDefault();
      userAction('use-suggested-view');
      dispatch(searchPerformed(search));
      dispatch(changeTab(EXPLORER));
      window.scrollTo(0, 0);
    },
    onStarClicked: (view, on) => () => {
      dispatch(starClicked(view, on));
    },
    userInteraction: (props) => (e) => {
      if (e) {
        e.preventDefault();
      }
      dispatch(modalInteraction(VIEWS_TAB, props));
    },
    onImportClicked: () => {
      dispatch(openModal(ModalImportViews, {}));
    },
    onCategoryClicked: (tag, filter) => {
      dispatch(
        modalInteraction(VIEWS_TAB, {
          section: 'filter',
          value: filter,
          categoryFilter: tag,
        }),
      );
    },
    onEditCategory: (tag) => (e) => {
      e.preventDefault();
      dispatch(openReactModal(<ModalEditCategory category={tag} />));
    },
    onDeleteCategory: (tag) => () => {
      dispatch(removeCategory(tag));
    },
    onEnterView: () => dispatch(changeTab(VIEWS)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SavedQueries);
